{
    "coordinates": [
        42.734637171880735,
        -98.04254362333498
    ],
    "tooltip": "Niobrara",
    "title": "Niobrara Formation",
    "country": "United States",
    "period": "Cretaceous",
    "alt": "TODO"
}
